import RebateGroupsRoutes from './RebateGroupsRoutes';

export const REBATEGROUP_BASE_ROUTES = '/rebategroups';

export { RebateGroupsRoutes };
